import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { UserContext } from '../contexts/index.jsx'
import { loadAdmins } from '../core/services/admin';

const prepareForOptions = (admins, allOption) => {
  if (!Array.isArray(admins)) {
    return [];
  }

  const asOptions = admins.map(admin => (
    { id: admin.id, name: `${admin.first_name} ${admin.last_name}` }
  ));

  return allOption ? [
    { id: null, name: 'All Users' },
    ...asOptions,
  ] : asOptions;
};

export const useAdmins = ({ forOptions = false, allOption = false } = {}) => {
  const { user } = useContext(UserContext)

  // `is_admin` is false on first render and true once the user context
  // resolves, so bailing out above the query changed the hook count on a
  // mounted component. The admin check is a fetch condition — it belongs in
  // `enabled`, which also keeps the request from firing for a client.
  const isAdmin = !!user?.is_admin;

  const query = useQuery({
    queryKey: ['admins'],
    queryFn: loadAdmins,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: isAdmin,
  });

  if (!isAdmin) {
    return {
      admins: [],
      status: 'success',
      error: null,
    };
  }

  return {
    admins: forOptions ? prepareForOptions(query.data, allOption) : (query.data || []),
    status: query.status,
    error: query.error,
  };
}
